import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledMuiIconButton = styled(IconButton)`
  padding: 1px;

  &:hover {
    svg: {
      color: #fff;
    }
  }
`;
